exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Content-module__content___geXQe{display:flex;flex-direction:column;gap:16px;max-width:340px}.Content-module__content___geXQe .Content-module__image-wrapper___32XFu{width:100%;background-color:#e8f7fc;border-radius:18px;aspect-ratio:16/9;position:relative;overflow:hidden}.Content-module__content___geXQe .Content-module__image-wrapper___32XFu img{-o-object-fit:cover;object-fit:cover;position:absolute;height:100%;width:100%}.Content-module__content___geXQe .Content-module__text-wrapper___3yFai{display:flex;flex-direction:column;gap:4px}", ""]);

// exports
exports.locals = {
	"content": "Content-module__content___geXQe",
	"image-wrapper": "Content-module__image-wrapper___32XFu",
	"text-wrapper": "Content-module__text-wrapper___3yFai"
};